import { AbstractBitmapText } from "../../../../abstracts/graphics/AbstractBitmapText";
import { ApocalypseFontsNames } from "../../../assetsLoader/ApocalypseAssetsNames";

const bitmapPool: AbstractBitmapText[] = [];

export const getBitmapText = (): AbstractBitmapText => {
    if (bitmapPool.length > 0) {
        return bitmapPool.pop()!;
    }

    return new AbstractBitmapText({
        text: ``,
        style: {
            fontName: ApocalypseFontsNames.APOCALYPSE_WHITE,
            fontSize: 6,
        },
    });
};

export const returnBitmapText = (bitmapText: AbstractBitmapText) => {
    bitmapText.reset();
    if (bitmapText.parent) bitmapText.parent.removeChild(bitmapText);

    bitmapPool.push(bitmapText);
};
